import Services from "services";

const Mock = {
  get: (url, params) =>
    new Promise((res, rej) =>
      setTimeout(() => {
        switch (url) {
          case "/hrdu/pengajuan_petty_cash/page":
            res({
              data: {
                data: [
                  {
                    tgl_pengajuan_petty_cash: "2022-11-01",
                    no_pengajuan_petty_cash: "2022/02/HRDU/PC/000001",
                    nama_proyek: "testing",
                    id_proyek: "1",
                    keperluan: "coba keperluan pengajuan",
                  },
                ],
                total_page: 1,
              },
            });
            break;

          case "/v1/example/single":
            res({
              data: {
                tanggal: "2020-01-01",
                keterangan: "",
                karyawan: Array.from({ length: 2 }).map((_, i) => ({
                  id: i + 1,
                  nama: `User ${i + 1}`,
                })),
                detail: Array.from({ length: 50 }).map((_, i) => ({
                  barang: `Barang ${i}`,
                  qty: i + 10,
                  harga: i + 1000,
                })),
              },
            });
            break;

          case "/hrdu/pengajuan_petty_cash/d_proyek":
            res({
              data: Array.from({ length: 50 }).map((_, i) => ({
                id: i,
                nama: `User ${i}`,
              })),
            });
            break;

          case "/hrdu/pengajuan_petty_cash/no_baru":
            res({
              data: { data: "2022/02/HRDU/PC/000001" },
            });
            break;

          default:
            res({});
        }
      }, 500)
    ),
  post: (url, params) =>
    new Promise((res, rej) => setTimeout(() => res("berhasil"), 500)),
  patch: (url, params) =>
    new Promise((res, rej) => setTimeout(() => res("berhasil"), 500)),
  put: (url, params) =>
    new Promise((res, rej) => setTimeout(() => res("berhasil"), 500)),
  delete: (url, params) =>
    new Promise((res, rej) => setTimeout(() => res("berhasil"), 500)),
};

class PengajuanPettyCashApi {
  async getList(params) {
    const fetch = await Services.get("/hrdu/pengajuan_petty_cash/page", {
      params,
    });
    return fetch.data;
  }

  getSingle(params) {
    return Services("/hrdu/pengajuan_petty_cash/form_single/", { params });
  }

  async getDropdownUnitProduksi() {
    const fetch = await Services.get(
      "/hrdu/pengajuan_petty_cash/unit_produksi_available"
    );
    return fetch?.data?.data?.map((val) => ({
      label: val.nama_unit_produksi,
      value: val.id_unit_produksi,
      limit_petty_cash: val.limit_petty_cash,
      id_penerima_petty_cash: val.id_penerima_petty_cash,
      id_pekerja: val.id_pekerja,
    }));
  }

  async getDropdownStatusApproval() {
    return [
      { label: "PENDING", value: "PEN" },
      {
        value: "VER",
        label: "VERIFIED",
      },
      {
        value: "APP",
        label: "APPROVED",
      },
      {
        value: "REV",
        label: "REVISI",
      },
      {
        value: "REJ",
        label: "REJECT",
      },
    ];
  }

  getAkumulasi(params) {
    return Services.get("/hrdu/pengajuan_petty_cash/akumulasi", { params });
  }

  generateNumber(params) {
    return Services.get("/hrdu/pengajuan_petty_cash/no_baru", { params });
  }

  create(data) {
    return Services.post("/hrdu/pengajuan_petty_cash", data);
  }

  update(data) {
    return Services.put("/hrdu/pengajuan_petty_cash", data);
  }
}

export default new PengajuanPettyCashApi();
